import { ThemeProvider } from '@helvetia/components/theme'
import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { Router } from 'react-router'
import { Route, Switch } from 'react-router-dom'

import Layout from './_components/Layout'
import PrivateRoute from './_components/PrivateRoute'
import history from './_utils/history'
import { Portal } from './AgentBroker/Portal'
import { SignUp } from './AgentBroker/SignUp'
import { Calculator } from './Calculator/Calculator.routes'
import { ContactMe } from './ContactMe'
import { Contract } from './Contract/Contract.routes'
import GlobalErrorHandler from './GlobalErrorHandler'
import InitialLoading from './InitialLoading'
import Landing from './Landing'
import { LogIn } from './LogIn'
import { NotAllowed } from './NotAllowed'
import { NotAuthorized } from './NotAuthorized'
import { NotFound } from './NotFound'
import { SaveAndRetreive } from './SaveAndRetreive'
import { Summary } from './Summary'

const Root: React.SFC<WithNamespaces> = () => (
  <ThemeProvider>
    <Layout history={history}>
      <Router history={history}>
        <GlobalErrorHandler history={history}>
          <Switch>
            <Route path="/home" exact component={Landing} />
            <Route path="/contact-me" component={ContactMe} />
            <Route path="/" exact component={Landing} />
            <InitialLoading>
              <Switch>
                <Route path="/calculator" component={Calculator} />
                <Route path="/summary" component={Summary} />
                <Route path="/contract" component={Contract} />
                <Route path="/save-and-retrieve" component={SaveAndRetreive} />
                <Route
                  path={`/login/:userId?`}
                  render={({ match }) => <LogIn userId={match.params.userId} />}
                />
                <PrivateRoute
                  authorizedRoles={[
                    process.env.REACT_APP_ROLE_BROKER,
                    process.env.REACT_APP_ROLE_ADMIN,
                    process.env.REACT_APP_ROLE_AGENT,
                  ]}
                  component={Portal}
                  path="/portal"
                  exact
                />
                <PrivateRoute
                  authorizedRoles={[
                    process.env.REACT_APP_ROLE_BROKER,
                    process.env.REACT_APP_ROLE_ADMIN,
                    process.env.REACT_APP_ROLE_AGENT,
                  ]}
                  path="/portal/sign-up"
                  component={SignUp}
                />
              </Switch>
            </InitialLoading>
            <Route path="/401" ecxact component={NotAuthorized} />
            <Route path="/403" exact component={NotAllowed} />
            <Route path="/404" exact component={NotFound} />
          </Switch>
        </GlobalErrorHandler>
      </Router>
    </Layout>
  </ThemeProvider>
)

export default withNamespaces()(Root)
